export default __webpack_public_path__ + "8f4411e540661268ddecd582edc6baa3.png";